(function () {
    const CENTER = 'sas-window-center';
    const FLANK = 'sas-window-flank';
    const BLOCKED = 'sas-window-blocked';

    function clear(calendar) {
        calendar
            .querySelectorAll('.' + CENTER + ', .' + FLANK + ', .' + BLOCKED)
            .forEach((el) => el.classList.remove(CENTER, FLANK, BLOCKED));
    }

    function paint(day) {
        const calendar = day.closest('.flatpickr-calendar');
        if (!calendar) return;
        clear(calendar);
        day.classList.add(CENTER);
        [day.previousElementSibling, day.nextElementSibling].forEach((el) => {
            if (!el || !el.classList.contains('flatpickr-day')) return;
            el.classList.add(
                el.classList.contains('flatpickr-disabled') ? BLOCKED : FLANK
            );
        });
    }

    function paintSelected() {
        document.querySelectorAll('.flatpickr-calendar').forEach((calendar) => {
            const selected = calendar.querySelector('.flatpickr-day.selected');
            if (selected) paint(selected);
            else clear(calendar);
        });
    }

    // Desktop: preview on hover
    document.addEventListener('mouseover', (event) => {
        const day = event.target.closest?.('.flatpickr-day');
        if (day && !day.classList.contains('flatpickr-disabled')) paint(day);
    });

    // Leaving the calendar restores the selected window
    document.addEventListener('mouseleave', (event) => {
        if (event.target?.classList?.contains('flatpickr-calendar')) paintSelected();
    }, true);

    // Mobile tap + desktop click + month navigation
    document.addEventListener('click', (event) => {
        if (event.target.closest?.('.flatpickr-calendar')) {
            setTimeout(paintSelected, 0);
        }
    }, true);
})();